import React, { createContext, useState, useCallback, useEffect, useRef } from "react";
import { fetchMyProfileApi } from "../api/raceStudentsApi";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(
      JSON.parse(sessionStorage.getItem("currentUser")) || null
  );

  const didInitRef = useRef(false);

  const persist = (userData) => {
    if (userData) {
      sessionStorage.setItem("currentUser", JSON.stringify(userData));
    } else {
      sessionStorage.removeItem("currentUser");
    }
  };

  const login = (userData) => {
    setUser(userData);
    persist(userData);
  };

  const logout = () => {
    setUser(null);
    sessionStorage.clear();
  };

  const refreshUser = useCallback(async () => {
    const res = await fetchMyProfileApi();
    setUser(res.admin);
    persist(res.admin);
    return res.admin;
  }, []);

  useEffect(() => {
    if (didInitRef.current) return;
    didInitRef.current = true;

    const stored = sessionStorage.getItem("currentUser");
    if (!stored) return;

    refreshUser().catch(() => {
    });
  }, [refreshUser]);

  return (
      <AuthContext.Provider value={{ user, login, logout, refreshUser }}>
        {children}
      </AuthContext.Provider>
  );
};

export default AuthProvider;